// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rectangle } from '@shared/commons/Geometry';
import { Resources } from '@shared/localizations/Resources';
import { TerceraWindowBase } from '../../screen/TerceraWindowBase';
import { ControlsUtils } from '../../UtilsClasses/ControlsUtils';
import { MainWindowManager } from '../../UtilsClasses/MainWindowManager';
import { ControlEvents } from '../Control';
import { QuickTreeNode } from '../QuickTree/QuickTreeNode';
import { TerceraQuickTreeEvents } from '../QuickTree/TerceraQuickTree';
import { TextBoxEvents } from '../TerceraTextBox';
export class TerceraLookupDropDownForm extends TerceraWindowBase {
    constructor() {
        super(...arguments);
        this.callBack = null;
        this.closeCallback = null;
        this.textBox = null;
        this.quickTree = null;
        this.items = null;
        this.currentNameFilter = null;
        this.oldNameFilter = null;
        this.asyncPopulateInterval = null;
        this.selectedItem = null;
        this.isMultiSelect = false;
        this.isMultiSelectMode = false;
        this.forceCloseOnLogout = false;
        this.caller = null;
    }
    getType() {
        return 'TerceraLookupDropDownForm';
    }
    oninit() {
        super.oninit();
        this.OnCompliteWaiter = new Promise((resolve, reject) => {
            this._complete_finished = resolve;
        });
    }
    oncomplete() {
        super.oncomplete();
        this.initializationComponents();
        this.on(ControlEvents.LostFocus, function () {
            // remove call stack overflow
            const caller = this.caller;
            this.caller = null;
            // TODO unificate  AfterLostFocusWaiting
            if (!isNullOrUndefined(caller) && !this.AfterLostFocusWaiting) {
                caller.setFocus();
            }
        }.bind(this));
        this.quickTree.on(TerceraQuickTreeEvents.DoubleClick, function () {
            if (this.quickTree.quickTree.isMultiSelectCheckboxUsing)
                return;
            this.onAddBtnClicked(); // #84756 (2nd issue)
            this.hide();
        }.bind(this));
        this.quickTree.on(TerceraQuickTreeEvents.EnterPress, this.onEnterPressed.bind(this));
        this.textBox.on(TextBoxEvents.TextChanged, function (context, value) {
            this.currentNameFilter = value === '' ? null : value.toLowerCase();
            this.populateAsync();
        }.bind(this));
        this.quickTree.quickTree.SelectionChanged.Subscribe(this.selectionChanged, this);
        this.selectionChanged();
        this.localize();
        // Promise
        this._complete_finished(this);
        this._complete_finished = null;
        this.OnCompliteWaiter = null;
    }
    localize() {
        super.localize();
        void this.set({
            selectAllText: Resources.getResource('TerceraAccountLookup.Select All'),
            multiSelectText: Resources.getResource('TerceraAccountLookup.Multy select'),
            cancelBtnText: Resources.getResource('panel.TerceraSymbolLookupDropDownForm.Cancel')
        });
    }
    initializationComponents() {
        throw new Error('Not implemented');
    }
    onAddBtnClicked(isBtnClick = false) {
        var _a;
        if (isBtnClick && !this.get('enabledAddBtn')) {
            return;
        }
        const qt = this.quickTree.quickTree;
        if (this.get('isMultiSelect')) {
            if (!isNullOrUndefined(this.callBack) && !isNullOrUndefined(qt.selectedNodesDict)) {
                let result = [];
                const dict = qt.selectedNodesDict;
                const keys = Object.keys(dict);
                const len = keys.length;
                for (let i = 0; i < len; i++) {
                    const curNode = dict[keys[i]];
                    if (((_a = curNode.childNodes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        result = result.concat(this.recursionAddCheckedResults(curNode.childNodes));
                    }
                    else if (!isNullOrUndefined(curNode.tag) && this.isValidResult(curNode.tag)) {
                        result.push(curNode.tag);
                    }
                }
                this.callBack(result);
            }
        }
        else if (!isNullOrUndefined(this.callBack) && !isNullOrUndefined(qt.selectedNode)) {
            this.callBack(qt.selectedNode.tag);
        }
        this.close();
    }
    isValidResult(nodeTag) {
        return true;
    }
    onEnterPressed() {
        // TODO.
        if (!this.get('enabledAddBtn')) {
            return;
        }
        this.onAddBtnClicked();
    }
    selectionChanged() {
        const qt = this.quickTree.quickTree;
        if (this.get('isMultiSelect')) {
            const len = this.getSelectedNodesCount();
            void this.set({
                addBtnText: Resources.getResource('panel.TerceraSymbolLookupDropDownForm.Add') + (len ? '[' + len + ']' : ''),
                enabledAddBtn: this.isButtonAddEnable()
            });
            this.changeCheckedNodes();
            qt.Draw();
        }
        else {
            void this.set({
                addBtnText: Resources.getResource('panel.TerceraSymbolLookupDropDownForm.Add'),
                enabledAddBtn: this.isButtonAddEnable()
            });
        }
    }
    changeCheckedNodes() {
        const qt = this.quickTree.quickTree;
        const nodesArr = qt.nodeCollection;
        if (nodesArr.length > 0) {
            for (const node of nodesArr) {
                const childNodesArr = node.childNodes;
                if (childNodesArr.length > 0) {
                    node.checked = true;
                    for (const child of childNodesArr) {
                        if (qt.selectedNodesDict[child.nodeText + node.nodeText]) {
                            child.checked = true;
                        }
                        else {
                            child.checked = false;
                            node.checked = false;
                        }
                    }
                }
            }
        }
    }
    getSelectedNodesCount() {
        const qt = this.quickTree.quickTree;
        return !isNullOrUndefined(qt.selectedNodesDict) ? Object.keys(qt.selectedNodesDict).length : 0;
    }
    isButtonAddEnable() {
        var _a;
        const qt = this.quickTree.quickTree;
        if (this.get('isMultiSelect')) {
            const len = !isNullOrUndefined(qt.selectedNodesDict) ? Object.keys(qt.selectedNodesDict).length : 0;
            return !!len;
        }
        else {
            return !isNullOrUndefined((_a = qt.selectedNode) === null || _a === void 0 ? void 0 : _a.tag);
        }
    }
    recursionAddCheckedResults(nodes) {
        let result = [];
        const len = nodes.length;
        for (let i = 0; i < len; i++) {
            const curNode = nodes[i];
            if (curNode.childNodes.length > 0) {
                result = result.concat(this.recursionAddCheckedResults(curNode.childNodes));
            }
            else if (!isNullOrUndefined(curNode.tag) && this.isValidResult(curNode.tag)) {
                result.push(curNode.tag);
            }
        }
        return result;
    }
    close() {
        const qt = this.quickTree.quickTree;
        qt.selectedNodesDict = {};
        qt.selectedNode = null;
        if (!isNullOrUndefined(this.AfterLostFocusWaiting)) {
            this.AfterLostFocusWaiting.setFocus();
            this.AfterLostFocusWaiting = null;
        }
        if (!isNullOrUndefined(this.closeCallback)) {
            this.closeCallback();
        }
        void this.set('visible', false);
    }
    showForm(parametersStruct) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.themeChange();
            this.setParentPanel(parametersStruct.parentPanel);
            void this.set('visible', true);
            if (!isNullOrUndefined(parametersStruct.caller)) {
                yield this.set('parentContainerControl', parametersStruct.caller);
            }
            const isMultiSelect = !!parametersStruct.isMultiSelect;
            void this.set('isMultiSelect', isMultiSelect);
            this.quickTree.setIsMultiSelect(isMultiSelect);
            if (parametersStruct.isMultiSelectCheckboxUsing) {
                this.quickTree.quickTree.isMultiSelect = false;
            }
            this.quickTree.quickTree.isMultiSelectCheckboxUsing = !!parametersStruct.isMultiSelectCheckboxUsing;
            this.quickTree.quickTree.UseCHB = !!parametersStruct.isMultiSelectCheckboxUsing;
            void this.set('isShowFooterBtn', isMultiSelect || !!parametersStruct.showButtons);
            void this.set({ isShowSelectAll: parametersStruct.isShowSelectAll });
            void this.set('isOptionMasterMode', parametersStruct.isOptionMasterMode);
            void this.set('isAutoCloseOld', (_a = parametersStruct.autoClose) !== null && _a !== void 0 ? _a : true);
            const newCoord = ControlsUtils.CorrectPopupLocation(new Rectangle(parametersStruct.x, parametersStruct.y, this.get('width'), this.get('height')), null);
            this.setLocation(newCoord.newX, newCoord.newY);
            this.callBack = parametersStruct.callBack;
            this.closeCallback = parametersStruct.closeCallback;
            this.items = parametersStruct.items;
            this.selectedItem = parametersStruct.selectedItem;
            this.dataProvider = parametersStruct.dataProvider;
            this.showMAM = parametersStruct.showMAM;
            this.isOptionMasterMode = parametersStruct.isOptionMasterMode;
            this.instrTypesToIgnore = parametersStruct.instrTypesToIgnore;
            this.fillTree();
            this.cachedItems = parametersStruct.items;
            this.textBox.setFocus();
            this.textBox.set({
                text: '',
                placeholder: Resources.getResource('screen.lookup.scripts.watermark')
            });
            if (!isNullOrUndefined(parametersStruct.caller)) {
                this.caller = parametersStruct.caller;
            }
            if (parametersStruct.isCentered) {
                this.center();
            }
            this.localize();
        });
    }
    hide() {
        const qt = this.quickTree.quickTree;
        if (!isNullOrUndefined(this.callBack) && !isNullOrUndefined(qt.selectedNode)) {
            this.callBack(qt.selectedNode.tag);
        }
        this.currentNameFilter = null;
        this.oldNameFilter = null;
        this.close();
    }
    populateAsync() {
        clearTimeout(this.asyncPopulateInterval);
        this.asyncPopulateInterval = null;
        this.asyncPopulateInterval = setTimeout(this.fillTree.bind(this), 300);
    }
    fillTree() {
        const items = this.items;
        const selectedItem = this.selectedItem;
        let selectedNode;
        const len = items.length;
        const nodeRange = [];
        for (let i = 0; i < len; i++) {
            const curItem = items[i];
            if (this.currentNameFilter !== null) {
                const curItemFindStr = curItem.toString().toLowerCase();
                if (!curItemFindStr.includes(this.currentNameFilter)) {
                    continue;
                }
            }
            const node = new QuickTreeNode(curItem.toString());
            node.tag = curItem;
            if (selectedItem === curItem) {
                selectedNode = node;
                node.selected = true;
            }
            nodeRange.push(node);
        }
        this.quickTree.quickTree.Clear();
        this.quickTree.quickTree.AddNodeRange(nodeRange);
        this.quickTree.quickTree.setSelectedNode(selectedNode);
        this.quickTree.quickTree.goToSelectedNode();
    }
    themeChange() { }
    afterParentPanelTeardownCallback() {
        this.hide();
    }
    static createInstance() {
        const lookup = new TerceraLookupDropDownForm();
        lookup.setBounds(200, 200, 200, 200);
        void lookup.set({
            visible: false
        });
        MainWindowManager.AddControl(lookup);
        return lookup;
    }
}
TerceraWindowBase.extendWith(TerceraLookupDropDownForm, {
    data: function () {
        return {
            showHeader: false,
            showFooter: false,
            movable: false,
            resizable: false,
            isLookup: true,
            isMultiSelect: false,
            multiSelectText: '',
            addBtnText: '',
            cancelBtnText: '',
            enabledAddBtn: false,
            isOptionMasterMode: false
        };
    }
});
